// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y_2p","left":"styles_left__EoH1_"};